import * as z from 'zod';

import { fileQuerySchema } from '@/_schemas/file';
import { statusQuerySchema } from '@/_schemas/status-input';

export const contactQueryLinkerSchema = z.object({
  id: z.number(),
  first_name: z.string(),
  last_name: z.string().nullable(),
  status: statusQuerySchema,
  profile_image: z.array(fileQuerySchema).nullish(),
  title: z.string().nullable(),
});

export type ContactQueryLinkerSchema = z.infer<typeof contactQueryLinkerSchema>;
